// extracted by mini-css-extract-plugin
export default {"cell":"SellingCell_cell__MSjw5"};